var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import * as ToastPrimitive from '@radix-ui/react-toast';
import getPosition from './private/utils/getPosition';
import mergeClassnames from '../mergeClassnames/mergeClassnames';
import ControlsCloseSmall from '../private/icons/ControlsCloseSmall';
const SnackbarRoot = (_a) => {
    var { autoClose, position = 'top-right', children, ref, className, isOpen, onOpenChange } = _a, rest = __rest(_a, ["autoClose", "position", "children", "ref", "className", "isOpen", "onOpenChange"]);
    return (React.createElement(ToastPrimitive.Provider, { swipeDirection: "right", duration: autoClose },
        React.createElement(ToastPrimitive.Root, Object.assign({ open: isOpen, onOpenChange: onOpenChange, ref: ref, "aria-live": "polite", className: mergeClassnames('z-50 flex fixed w-[calc(100%-32px)] md:w-fit transition', 'radix-state-closed:animate-toast-hide radix-swipe-end:animate-toast-swipe-out', 'translate-x-radix-toast-swipe-move-x radix-swipe-cancel:translate-x-0', 'radix-swipe-cancel:duration-200 radix-swipe-cancel:ease-[ease]', getPosition(position)) }, rest),
            React.createElement("div", { className: mergeClassnames('flex w-fit max-w-xs items-center gap-4 p-4 bg-goku shadow-moon-lg rounded-moon-s-sm', className) }, children)),
        React.createElement(ToastPrimitive.Viewport, null)));
};
const Header = (_a) => {
    var { children, className } = _a, rest = __rest(_a, ["children", "className"]);
    return (React.createElement("p", Object.assign({ className: mergeClassnames('w-full text-moon-14 font-medium transition-colors text-bulma', className) }, rest), children));
};
const Message = (_a) => {
    var { children, className } = _a, rest = __rest(_a, ["children", "className"]);
    return (React.createElement("p", Object.assign({ className: mergeClassnames('w-full text-moon-14 transition-colors text-bulma', className) }, rest), children));
};
const Content = (_a) => {
    var { children, className } = _a, rest = __rest(_a, ["children", "className"]);
    return (React.createElement("div", Object.assign({ className: mergeClassnames('w-full', className) }, rest), children));
};
const Icon = (_a) => {
    var { children, className } = _a, rest = __rest(_a, ["children", "className"]);
    return (React.createElement("div", Object.assign({ "aria-hidden": "true", className: mergeClassnames('flex h-8 aspect-square items-center justify-center rounded-moon-s-sm text-moon-32', className) }, rest), children));
};
const Close = (_a) => {
    var { className, ariaLabel = 'Close' } = _a, rest = __rest(_a, ["className", "ariaLabel"]);
    return (React.createElement(ToastPrimitive.Close, Object.assign({ "aria-label": ariaLabel, className: mergeClassnames('flex h-8 aspect-square items-center justify-center text-bulma text-moon-24', className) }, rest),
        React.createElement(ControlsCloseSmall, null)));
};
const Snackbar = Object.assign(SnackbarRoot, {
    Content,
    Header,
    Message,
    Close,
    Icon,
});
export default Snackbar;
